export const getCustomerPhone = (item) =>
  String(item?.telefono || item?.phone || item?.customerData?.phone || '').trim();

export const buildWhatsAppUrl = (rawPhone, prefillText) => {
  let digits = String(rawPhone || '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.startsWith('00')) digits = digits.slice(2);
  if (!digits.startsWith('54')) {
    if (digits.startsWith('0')) digits = digits.slice(1);
    digits = `54${digits}`;
  }
  if (digits.length < 11) return '';
  const url = new URL(`https://wa.me/${digits}`);
  if (prefillText) url.searchParams.set('text', prefillText);
  return url.toString();
};
